import s from './Assistant.module.sass';
import { FC, useEffect, useState } from 'react';
import { Block, Button } from '$uikit';
import { scrollToBottom, statReachGoal } from '$utils';
import { useDispatch, useSelector } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { imActions, imSelector } from '$store/im';
import { IcClose16 } from '$assets';

const ASSISTANT_CLOSED_KEY = 'assistant_closed';

export const Assistant: FC<{ peerId: number }> = ({ peerId }) => {
  const dispatch = useDispatch();
  const { aiOptions: options } = useSelector(imSelector);
  const [isClosed, setIsClosed] = useState(
    () => sessionStorage.getItem(ASSISTANT_CLOSED_KEY) === '1',
  );

  const handleClose = () => {
    sessionStorage.setItem(ASSISTANT_CLOSED_KEY, '1');
    setIsClosed(true);
  };

  useEffect(() => {
    if (!isClosed) {
      statReachGoal('assistant_form');
    }
  }, [isClosed]);

  const handleOption = (option: string) => {
    dispatch(
      imActions.chatSetFormText({
        peerId,
        text: option,
      }),
    );

    statReachGoal('assistant_apply');
  };

  const handleGenerate = () => {
    dispatch(toastActions.setToastLoading());
    Api.post<
      any,
      {
        options: string[];
      }
    >(`/assistant/chat/${peerId}/suggest`)
      .then((resp) => {
        dispatch(toastActions.hideToast());
        dispatch(imActions.setAIOptions(resp.options));
        setTimeout(() => {
          scrollToBottom('chat_history');
        }, 100);

        statReachGoal('assistant_generate');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  };

  if (isClosed) {
    return null;
  }

  return (
    <div className={s.wrap}>
      <Block className={s.content}>
        <div className={s.header}>
          <div className={s.title}>Ton.Place Assistant</div>
          <div className={s.button}>
            <Button size="small" mode="tertiary" onClick={handleGenerate}>
              Generate
            </Button>
          </div>
          <div className={s.close} onClick={handleClose}>
            <IcClose16 />
          </div>
        </div>
        {options.length > 0 && (
          <div className={s.options}>
            {options.map((option, i) => (
              <div key={i} className={s.optionWrap}>
                <div
                  className={s.option}
                  onClick={() => {
                    handleOption(option);
                  }}
                >
                  {option}
                </div>
              </div>
            ))}
          </div>
        )}
      </Block>
    </div>
  );
};
